import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { handlerApiError, toastSuccess } from '@helpers/function.helper';
import { Product } from '@models/product.model';
import { CartService } from '@services/cart.service';
import { finalize } from 'rxjs';
import { ImagePipe } from '../../../core/pipes/image.pipe';
import { VndPipe } from '../../../core/pipes/vnd.pipe';
import { IconComponent } from '../../icon/icon.component';
import { DialogBottomUpBaseComponent } from '../dialog-bottom-up/dialog-bottom-up.base.component';
import { DialogBottomUpComponent } from '../dialog-bottom-up/dialog-bottom-up.component';

@Component({
  selector: 'market-add-to-cart-bottom-up',
  standalone: true,
  templateUrl: './add-to-cart-bottom-up.component.html',
  styleUrl: './add-to-cart-bottom-up.component.scss',
  imports: [
    CommonModule,
    DialogBottomUpComponent,
    ImagePipe,
    IconComponent,
    VndPipe,
    FormsModule,
  ],
})
export class AddToCartBottomUpComponent extends DialogBottomUpBaseComponent {
  private cartService = inject(CartService);

  quantity = signal(0);

  product = signal<Product | null>(null);
  loading = signal(false);

  get totalPrice() {
    const product = this.product();
    if (!product) return 0;
    return (product.salePrice || product.price) * this.quantity();
  }

  public showModal(product: Product) {
    this.dialogBottomUp.showModal();
    this.product.set(product);
    const quantity =
      this.cartService
        .cart()
        ?.items.find(item => item.product.id === product.id)?.quantity ?? 1;
    this.quantity.set(quantity);
  }

  cartButtonClickHandler() {
    const product = this.product();
    if (!product) return;
    this.loading.set(true);
    this.cartService
      .updateCartItemQuantity(product.id, this.quantity())
      .pipe(
        finalize(() => {
          this.dialogBottomUp.hideModal();
          this.loading.set(false);
        })
      )
      .subscribe({
        next: () => toastSuccess('Cập nhật giỏ hàng thành công'),
        error: err => handlerApiError(err, 'Cập nhật giỏ hàng thất bại'),
      });
  }

  updateQuantity(addUnit: number) {
    this.quantity.update(prev => prev + addUnit);
  }

  quantityChange($event: number) {
    this.quantity.set(Math.abs(+$event));
  }
}
